<div class="main">
    <sidebar [hideSidebarRoute]="['auth']"
             [items]="menus"
             [profileMenu]="profileMenu"
             profileRoute="/profile"
    ></sidebar>
    <div class="w-100 vh-100">
        <router-outlet></router-outlet>
    </div>
    <ngx-loading [show]="loader.loader$ | async"></ngx-loading>
</div>
